import { title } from 'process'
import { connect } from 'react-redux'
import renderPrgImage from '../../../source/programImg'
import '../../Assembly/AiModeSelect/AiModeSelect.css'
import {
    appAiBytesGeneration,
    fetchAudioList,
    fetchFaceList,
    fetchSpeechList,
} from '../../AppMode/AppModeAI/AppModeAiBytesGeneration'
import { useEffect, useRef } from 'react'
import { removeAssemblyPageAiComponents } from '../../../utils/removeSensorProgramData'
import { getDeviceName } from '../../../utils/utils'
// import { checkOk, timeoutPromise } from '../../../utils/workerReadSupport'

const pcAiAccessories = {
    row1: {
        ai_motion: {
            title: 'Motion',
            activeImg: 'ai_motionActive',
            inActiveImg: 'ai_motion',
        },
    },
    row2: {
        ai_color_recognition: {
            title: 'Color Recognition',
            activeImg: 'ai_color_recognitionActive',
            inActiveImg: 'ai_color_recognition',
        },
        ai_color_tracking: {
            title: 'Color Tracking',
            activeImg: 'ai_color_trackingActive',
            inActiveImg: 'ai_color_tracking',
        },
    },
    row3: {
        ai_face_detection: {
            title: 'face Detection',
            activeImg: 'ai_face_detectionActive',
            inActiveImg: 'ai_face_detection',
        },
        ai_face_recognition: {
            title: 'Face Recognition',
            activeImg: 'ai_face_recognitionActive',
            inActiveImg: 'ai_face_recognition',
        },
        ai_face_tracking: {
            title: 'Face Tracking',
            activeImg: 'ai_face_trackingActive',
            inActiveImg: 'ai_face_tracking',
        },
    },
    row4: {
        ai_mic: {
            title: 'Mic',
            activeImg: 'ai_micActive',
            inActiveImg: 'ai_mic',
        },
        ai_lidar: {
            title: 'Lidar',
            activeImg: 'ai_lidarActive',
            inActiveImg: 'ai_lidar',
        },
    },
    row5: {
        ai_LED: {
            title: 'LED',
            activeImg: 'ai_LEDActive',
            inActiveImg: 'ai_LED',
        },
        ai_audio: {
            title: 'Audio',
            activeImg: 'buzzerActive',
            inActiveImg: 'buzzerInActive',
        },
    },
}

function AiModeSelect(props) {
    const assemblyPageAi = { ...props.assemblyTwo.assemblyPageAi }
    const connectDevice = sessionStorage.getItem('connectDevice') || 'Ace'

    const sendDataAsPacket = useRef(false)
    const fetchAudioListRef = useRef([])
    const fetchSpeechListRef = useRef([])
    const fetchFaceListRef = useRef([])

    const timeoutPromise = (ms) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                console.log('HHHHHHHHHH Time Out')
                reject(new Error('Timeout exceeded'))
            }, ms)
        })
    }

    const checkOk = async () => {
        return new Promise(async (resolve, reject) => {
            while (true) {
                if (!sendDataAsPacket.current) {
                    return resolve()
                }

                await new Promise((reslove) => {
                    setTimeout(reslove, 100)
                })
            }
        })
    }

    const handelClose = () => {
        let assemblyPageAi = { ...props.assemblyTwo.assemblyPageAi }
        assemblyPageAi.isShowAiSelectContainer = false
        props.setAssemblyPageAi(assemblyPageAi)
    }

    //fetch data from ai module
    const handleFetch = async (
        elementKey,
        fetchFunction,
        fetchType,
        message,
        errorMessage
    ) => {
        if (sendDataAsPacket.current) return

        if (!props?.webSerial?.isConnected) {
            props.showAiModelPopUp({
                elementKey: `Please ensure the ${getDeviceName(
                    connectDevice
                )} and AI-1 are connected before proceeding.`,
                text: true,
            })
            throw new Error('device not connected.')
        }

        props.showAiModelPopUp({ elementKey: message, text: true, time: 7400 })
        fetchFunction(props.worker)
        sendDataAsPacket.current = true

        try {
            await Promise.race([
                checkOk(sendDataAsPacket),
                timeoutPromise(7000),
            ])
        } catch {
            sendDataAsPacket.current = false
            props.showAiModelPopUp({
                elementKey: errorMessage,
                text: true,
            })
            if (elementKey !== 'ai_face_tracking') {
                throw new Error('Something went wrong!')
            }
        }
    }

    const handleClicks = async (elementKey) => {
        if (sendDataAsPacket.current) {
            return
        }

        let newAssemblyPageAi = { ...props.assemblyTwo.assemblyPageAi }
        let aiItems = { ...newAssemblyPageAi.aiItems }
        let node = props.logic.program

        // if (elementKey === 'ai_audio' && aiItems.ai_audio === false) {
        //     try {
        //         props.showAiModelPopUp({
        //             elementKey: 'Fetching the audio list....',
        //             text: true,
        //             time: 7400,
        //         })

        //         fetchAudioList(props.worker)
        //         sendDataAsPacket.current = true

        //         let replyOK = await Promise.race([
        //             checkOk(),
        //             timeoutPromise(7000), //
        //         ])
        //     } catch (e) {
        //         sendDataAsPacket.current = false
        //         props.showAiModelPopUp({
        //             elementKey: 'Something wrong, place try again.',
        //             text: true,
        //         })

        //         return
        //     }
        // }
        // if (
        //     elementKey === 'ai_face_recognition' &&
        //     aiItems.ai_face_recognition === false
        // ) {
        //     try {
        //         props.showAiModelPopUp({
        //             elementKey: 'Fetching the face list....',
        //             text: true,
        //             time: 7400,
        //         })

        //         fetchFaceList(props.worker)
        //         sendDataAsPacket.current = true
        //         //after get data send stop bytes
        //         let replyOK = await Promise.race([
        //             checkOk(),
        //             timeoutPromise(7000), //
        //         ])
        //     } catch (e) {
        //         sendDataAsPacket.current = false
        //         props.showAiModelPopUp({
        //             elementKey: 'Something wrong, place try again.',
        //             text: true,
        //         })

        //         return
        //     }
        // }
        // if (elementKey === 'ai_mic' && aiItems.ai_mic === false) {
        //     try {
        //         props.showAiModelPopUp({
        //             elementKey: 'Fetching the speech list....',
        //             text: true,
        //             time: 7400,
        //         })

        //         fetchSpeechList(props.worker)
        //         sendDataAsPacket.current = true

        //         let replyOK = await Promise.race([
        //             checkOk(),
        //             timeoutPromise(7000), //
        //         ])
        //     } catch (e) {
        //         sendDataAsPacket.current = false
        //         props.showAiModelPopUp({
        //             elementKey: 'Something wrong, place try again.',
        //             text: true,
        //         })

        //         return
        //     }
        // }
        try {
            if (elementKey === 'ai_audio' && !aiItems.ai_audio) {
                await handleFetch(
                    elementKey,
                    fetchAudioList,
                    'aiAudioList',
                    'Fetching the audio list...',
                    'MP3 files are not available. Please import the files to sd card.'
                )
            }
            if (
                (elementKey === 'ai_face_recognition' &&
                    !aiItems.ai_face_recognition) ||
                (elementKey === 'ai_face_tracking' && !aiItems.ai_face_tracking)
            ) {
                await handleFetch(
                    elementKey,
                    fetchFaceList,
                    'aiFaceList',
                    'Fetching the face list...',
                    'No face data found. Please train a face.'
                )
            }
            if (elementKey === 'ai_mic' && !aiItems.ai_mic) {
                await handleFetch(
                    elementKey,
                    fetchSpeechList,
                    'aiSpeechList',
                    'Fetching the speech list...',
                    'No speech data found. Please train a speech.'
                )
            }
        } catch (e) {
            return
        }

        newAssemblyPageAi = { ...props.assemblyTwo.assemblyPageAi }
        aiItems = { ...newAssemblyPageAi.aiItems }

        if (elementKey === 'ai_face_tracking' && !aiItems.ai_face_tracking) {
            if (fetchFaceListRef.current.length !== 0) {
                props.showAiModelPopUp({ elementKey, text: false })
            }
        } else {
            props.showAiModelPopUp({ elementKey, text: false })
        }

        removeAssemblyPageAiComponents({
            node,
            port: `${elementKey}A1`,
            type: elementKey,
            isRemove: aiItems[elementKey],
        })
        aiItems[elementKey] = !aiItems[elementKey]

        switch (elementKey) {
            case 'ai_motion':
                // removeAssemblyPageAiComponents({
                //     node,
                //     port: 'ai_motionA1',
                //     type: elementKey,
                //     isRemove: aiItems.ai_motion,
                // })
                // aiItems.ai_motion = !aiItems.ai_motion

                aiItems.ai_color_recognition = false
                aiItems.ai_color_tracking = false
                aiItems.ai_face_detection = false
                aiItems.ai_face_recognition = false
                aiItems.ai_face_tracking = false
                break

            case 'ai_color_recognition':
            case 'ai_color_tracking':
                // removeAssemblyPageAiComponents({
                //     node,
                //     port: `${elementKey}A1`,
                //     type: elementKey,
                //     isRemove: aiItems[elementKey],
                // })
                // aiItems[elementKey] = !aiItems[elementKey]

                aiItems.ai_motion = false
                aiItems.ai_face_detection = false
                aiItems.ai_face_recognition = false
                aiItems.ai_face_tracking = false
                break
            case 'ai_face_detection':
            case 'ai_face_recognition':
            case 'ai_face_tracking':
                // removeAssemblyPageAiComponents({
                //     node,
                //     port: `${elementKey}A1`,
                //     type: elementKey,
                //     isRemove: aiItems[elementKey],
                // })
                // aiItems[elementKey] = !aiItems[elementKey]

                aiItems.ai_motion = false
                aiItems.ai_color_recognition = false
                aiItems.ai_color_tracking = false
                break
            default:
            // removeAssemblyPageAiComponents({
            //     node,
            //     port: `${elementKey}A1`,
            //     type: elementKey,
            //     isRemove: aiItems[elementKey],
            // })
            // aiItems[elementKey] = !aiItems[elementKey]
        }

        if (fetchAudioListRef.current.length > 0) {
            newAssemblyPageAi.aiAudioList = fetchAudioListRef.current
            fetchAudioListRef.current = []
        }
        if (fetchFaceListRef.current.length > 0) {
            newAssemblyPageAi.aiFaceList = fetchFaceListRef.current
            fetchFaceListRef.current = []
        }
        if (fetchSpeechListRef.current.length > 0) {
            newAssemblyPageAi.aiSpeechList = fetchSpeechListRef.current
            fetchSpeechListRef.current = []
        }
        newAssemblyPageAi.aiItems = aiItems
        props.setAssemblyPageAi(newAssemblyPageAi)
    }

    //AI STOP TARIN bytes sending
    const sendStopTrainBytes = async () => {
        try {
            let getStoTrainBytes = appAiBytesGeneration('stopTrainByte')

            props.worker.postMessage({
                type: 'aiFetchAudioWriteArray',
                value: getStoTrainBytes,
            })
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        //read data from serial worker
        const messageHandler = (e) => {
            if (e.data.type === 'actionRead') {
                try {
                    let { arrayData, stringData } = e.data.value
                    let arrayDataStringFormat = arrayData.join(',')
                    // const regexEqu = /(?:\d+,\d+,28,)(.+)/
                    // const regexEqu = /(?<=\d+,\d+,28,)(.*?)(?=,\d+,255,245)/
                    // const fetchRegexEqu =
                    //     /^65,73,\d+,\d+,31,10,((?:\d+,)*?)10,\d+,255,245$/
                    // const fetchSpeechRegexEqu =
                    //     /^65,73,\d+,\d+,21,10,((?:\d+,)*?)10,\d+,255,245$/
                    // let match = arrayData.join(',').match(regexEqu)
                    // let fetchMatch = arrayData.join(',').match(fetchRegexEqu)
                    // let fetchSpeechMatch = arrayData
                    //     .join(',')
                    //     .match(fetchSpeechRegexEqu)
                    const regexPatterns = {
                        default: /(?<=\d+,\d+,28,)(.*?)(?=,\d+,255,245)/,
                        fetchRegexEqu: (num) =>
                            new RegExp(
                                `^65,76,\\d+,\\d+,${num},13,10,((?:\\d+,)*?)13,10,\\d+,255,245$`
                            ),
                    }

                    let match = arrayDataStringFormat.match(
                        regexPatterns.default
                    )
                    let fetchMatch = arrayDataStringFormat.match(
                        regexPatterns.fetchRegexEqu(31)
                    )
                    // console.log('HHHHHHHHHH', fetchMatch)
                    let fetchSpeechMatch = arrayDataStringFormat.match(
                        regexPatterns.fetchRegexEqu(21)
                    )

                    const processMatch = (match, ref, mood) => {
                        if (match) {
                            // const matchArr = match[1].slice(0, -1).split(',')
                            // const stringData = String.fromCharCode(...matchArr)
                            // let stringArr = stringData.split('\n\r')

                            const matchArr = match[1]
                                .slice(0, -1)
                                .split(',13,10,')
                            // console.log('HHHH11112222', matchArr1)
                            let resultArr = []
                            // console.log(stringArr)
                            // if ('Select Ai Speech' === label) {
                            resultArr.push({
                                label: 'Select',
                                id: '0',
                            })
                            for (
                                let i = 0;
                                i < matchArr.length - 1;
                                i = i + 2
                            ) {
                                let labelArr = matchArr[i + 1].split(',')

                                if (
                                    matchArr[i] === '101' &&
                                    mood === 'speech'
                                ) {
                                    resultArr.splice(1, 0, {
                                        label: String.fromCharCode(...labelArr),
                                        id: matchArr[i],
                                    })
                                } else {
                                    resultArr.push({
                                        label: String.fromCharCode(...labelArr),
                                        id: matchArr[i],
                                    })
                                }
                            }
                            // }
                            // else {
                            //     resultArr.push({
                            //         label: label,
                            //         id: '0',
                            //     })
                            //     for (let i = 0; i < matchArr.length; i++) {
                            //         let labelArr = matchArr[i].split(',')
                            //         resultArr.push({
                            //             label: String.fromCharCode(...labelArr),
                            //             id: i + 1,
                            //         })
                            //     }
                            // }
                            ref.current = resultArr
                            sendDataAsPacket.current = false
                            sendStopTrainBytes()
                        }
                    }

                    if (match) {
                        const matchArr = match[0].split(',')
                        const stringData = String.fromCharCode(...matchArr)
                        let stringArr = stringData.split('\n')
                        console.log(stringArr)
                        fetchAudioListRef.current = ['Select', ...stringArr]
                        sendDataAsPacket.current = false
                    } else {
                        processMatch(fetchMatch, fetchFaceListRef, 'face')
                        processMatch(
                            fetchSpeechMatch,
                            fetchSpeechListRef,
                            'speech'
                        )
                    }

                    // if (match) {
                    //     const matchArr = match[0].split(',')
                    //     const stringData = String.fromCharCode(...matchArr)
                    //     let stringArr = stringData.split('\n')
                    //     console.log(stringArr)

                    //     fetchAudioListRef.current = [
                    //         'Select Ai Audio',
                    //         ...stringArr,
                    //     ]
                    //     sendDataAsPacket.current = false
                    // } else if (fetchMatch) {
                    //     const matchArr = fetchMatch[1].slice(0, -1).split(',')
                    //     const stringData = String.fromCharCode(...matchArr)
                    //     let stringArr = stringData.split('\n')
                    //     console.log(stringArr)
                    //     fetchFaceListRef.current = [
                    //         'Select Ai Face',
                    //         ...stringArr,
                    //     ]
                    //     sendDataAsPacket.current = false
                    //     sendStopTrainBytes()
                    // } else if (fetchSpeechMatch) {
                    //     const matchArr = fetchSpeechMatch[1]
                    //         .slice(0, -1)
                    //         .split(',')
                    //     console.log('HHHHHHHH', matchArr)

                    //     const stringData = String.fromCharCode(...matchArr)
                    //     let stringArr = stringData.split('\n')
                    //     console.log(stringArr)
                    //     fetchSpeechListRef.current = [
                    //         'Select Ai Speech',
                    //         ...stringArr,
                    //     ]
                    //     sendDataAsPacket.current = false
                    //     sendStopTrainBytes()
                    // }
                } catch (e) {
                    console.log('ERROR', e)
                }
            }
        }

        props.worker.addEventListener('message', messageHandler)

        return () => {
            props.worker.removeEventListener('message', messageHandler)
        }
    }, [])

    return (
        <div className="aiModeSelectDiv">
            <img
                src={renderPrgImage('close')}
                style={{
                    position: 'absolute',
                    top: '-3%',
                    right: '-2%',
                    cursor: 'pointer',
                }}
                width="40px"
                alt="close"
                onClick={(e) => handelClose()}
            />
            <div className="aiModeSelect_container">
                {Object.keys(pcAiAccessories).map((rowKey, ind) => {
                    const row = pcAiAccessories[rowKey]
                    return (
                        <div key={rowKey} className="aiModeSelect_row">
                            {Object.keys(row).map((elementKey, ind) => {
                                return (
                                    <img
                                        key={ind}
                                        style={{ cursor: 'pointer' }}
                                        src={
                                            assemblyPageAi.aiItems[elementKey]
                                                ? renderPrgImage(
                                                      row[elementKey].activeImg
                                                  )
                                                : renderPrgImage(
                                                      row[elementKey]
                                                          .inActiveImg
                                                  )
                                        }
                                        // className="imgStyle_v1"
                                        width="20%"
                                        alt={row[elementKey].title}
                                        onClick={(e) =>
                                            handleClicks(elementKey)
                                        }
                                    />
                                )
                            })}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return state
}

const mapDispatchToProps = (dispatch) => {
    return {
        setAssemblyPageAi: (data) => {
            dispatch({ type: 'ASSEMBLY_PAGE_AI_TWO', payload: data })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AiModeSelect)
